module.exports = __webpack_public_path__ + "static/media/biz-rule-engine.40ed505e.png";